import { WidgetsPartiesMain } from '@/widgets/parties';

export const PagesPartiesMain = () => <WidgetsPartiesMain />;
